<template>
  <div class="analytics-creative-table border border-grayNeutralLight rounded-md overflow-hidden mb-0.5">
    <ElTable :data="creatives" style="width: 100%" :default-sort="{ prop: 'total_clicks', order: 'descending' }">
      <ElTableColumn prop="creative_name" label="Creative" sortable>
        <template #default="scope">
          <div class="flex items-center gap-0.5">
            <img
              v-if="scope.row.thumbnail"
              :src="imageSignature(scope.row.thumbnail)"
              :alt="scope.row.creative_name"
              class="w-7 h-7 object-cover rounded shrink-0"
            />

            <div v-else class="p-1.5 bg-[#F9F9FB] border border-grayNeutralLight rounded w-7 h-7 flex items-center justify-center shrink-0">
              <svg width="16" height="17">
                <use xlink:href="#screen"></use>
              </svg>
            </div>
          </div>
        </template>
      </ElTableColumn>

      <ElTableColumn prop="creative_name" label="Set" sortable>
        <template #default="scope"> {{ scope.row.creative_name }} </template>
      </ElTableColumn>

      <ElTableColumn prop="total_impressions" label="Impressions" sortable>
        <template #default="scope">
          {{ scope.row.total_impressions }}
        </template>
      </ElTableColumn>

      <ElTableColumn prop="total_clicks" label="Clicks" sortable>
        <template #default="scope">
          {{ scope.row.total_clicks }}
        </template>
      </ElTableColumn>

      <ElTableColumn prop="average_ctr" label="CTR" sortable>
        <template #default="scope"> {{ calculateCTR(scope.row.total_clicks, scope.row.total_impressions) }}% </template>
      </ElTableColumn>

      <ElTableColumn prop="total_viewable_impressions" label="Viewable Impressions" sortable>
        <template #default="scope">
          {{ calculateViewability(scope.row.total_viewable_impressions, scope.row.total_impressions) }}%
        </template>
      </ElTableColumn>
    </ElTable>
  </div>
</template>

<script>
import Vue from 'vue'
import { Table, TableColumn } from 'element-ui'
Vue.use(Table)
Vue.use(TableColumn)

export default {
  name: 'CreativeTable',
  props: {
    creatives: {
      type: Array,
      required: true,
    },
  },
  methods: {
    imageSignature(img) {
      return this.signature(img, 'socialproducts', 1)
    },
    formatNumber(val) {
      const num = Number(val)
      return isNaN(num) ? '—' : num.toLocaleString('en-US')
    },
    formatPercent(v) {
      if (v == null || isNaN(v)) return '0%'
      const val = Number(v)
      return `${parseFloat(val.toFixed(2))}%`
    },
    calculateViewability(viewableImpressions, totalImpressions) {
      if (!totalImpressions || totalImpressions === 0) return '0.00'
      const viewability = (viewableImpressions / totalImpressions) * 100
      return viewability.toFixed(2)
    },
    calculateCTR(clicks, impressions) {
      if (!impressions || impressions === 0) return '0.00'
      const ctr = (clicks / impressions) * 100
      // Use parseFloat to clean up floating point precision issues
      return parseFloat(ctr.toFixed(2))
    },
  },
}
</script>

<style lang="scss">
.analytics-creative-table {
  .el-table__cell {
    @apply py-2;
  }
  .cell {
    @apply text-13px text-grayNeutralDark px-2;
  }
  .el-table th.el-table__cell > .cell {
    @apply font-medium text-gray whitespace-nowrap px-2;
  }
}
</style>
